import { FeatureTypes } from "entity-app/constants";

export const BID_PACKAGE_LIST_VIEW = `BidPackageListQuery {
  bid_package_list_func {
    id
    auto_inc_value
    number
    title
    description
    wave
    workflow_status
    milestone_state
    next_planned_deadline
    due_date
    risk
    effective_float
    pre_WF_start_float
    feature_workflow_instance_id
    awarded_subcontractor_id
    awarded_subcontractor_name
    awarded_value
    estimated_value
    preconstruction_lead_first_name
    preconstruction_lead_id
    operations_lead_status_id
    preconstruction_lead_status_id
    preconstruction_lead_last_name
    operations_lead_first_name
    operations_lead_id
    operations_lead_last_name
    bid_package_template_id
    bid_package_template_name
    bid_package_template_id
    no_of_bidders
    bidding_subcontractors
    milestones
    offsets
    manual_entry_date
    onsite_estimate_date
    onsite_estimate_editable
    final_deadline_date
    projected_last_milestone_date
    projected_next_milestone_date
    planned_next_milestone_date
    last_manual_updated_at
    last_system_updated_at
    no_of_comments
    _custom_fields
    ready_for_release
    linked_design_packages
  }
  feature_workflow_instance(
    where: {
      wf_override_reason: { _is_null: false }
      feature_type_id: { _eq: ${FeatureTypes.BID_PACKAGE} }
    }
  ) {
    id
    wf_override_reason
  }
}`;

export const QUERY_GET_BID_PACKAGE_COLUMN_CONFIG = `
  GetSavedBidPackageColumnHeaders($where: project_users_bool_exp) {
    project_users(where: $where) {
      project_id
      bid_package_column_config
    }
  }
`;
